import type { RouteObject } from 'react-router';

import { PATHNAMES } from 'constants/constants';
import { lazyRoute } from 'utils/lazyRoute';

const InventionAssistant = lazyRoute(
  () => import('features/InventionAssistant/components/InventionAssistant'),
  m => m.InventionAssistant,
);

export const inventionAssistantRoutes: RouteObject[] = [
  { path: `${PATHNAMES.inventionAssistant}/:id`, lazy: InventionAssistant },
];
